(function() {
    /** @ngInject */
    function FullDayCacheFactory($http,Booking,$q) {
        return {
            fullDays : {},
            key_life : {},
            getFullDays : function(cache){
                var deff = $q.defer();
                var _self = this;
                if(settings.allow_full_seated_meals === 'Y') {
                    var fd_key = Booking.mealid + '_' + Booking.amount;
                    if(_.has(this.fullDays, fd_key)){
                        if(_.has(this.key_life,fd_key) && moment().diff(this.key_life[fd_key],'s') >= 60){
                            //expired in cache so just skip and let it fetch
                        }else {
                            //already in cache and so just explode it out
                            deff.resolve({dates: this.fullDays[fd_key]});
                            return deff.promise;
                        }
                    }
                    var meal = Booking.mealid > 0 ? _.find(meals, {id : Booking.mealid}) : false;

                    var dates = [];
                    _.forEach(Booking.meal.calendar, function (i, k) {
                        if (i === 1)
                            dates.push(k);
                    });
                    if(_.size(dates) <= 0) return false;
                    var blockedDates = [];
                    var ignore_ajax = true;
                    var full_dates_mealid = meal.id;
                    $http.post("/booking-widget/api/getCalendarTimes", {
                        from: _.head(dates),
                        to: _.last(dates),
                        date: _.head(dates),
                        available_dates: dates,
                        amount: Booking.amount,
                        mealid: Booking.mealid,
                        hash: hash
                    }).success(function (response) {
                        if (_.has(response, 'times') && _.size(response.times) > 0) {
                            blockedDates = response.times;
                        }
                        _self.key_life[fd_key] = moment();
                        _self.fullDays[fd_key] = blockedDates;
                        deff.resolve({dates : blockedDates});
                    });
                }else{
                    _self.key_life[fd_key] = moment();
                    _self.fullDays[fd_key] = blockedDates;
                    deff.resolve({dates : []});
                }
                return deff.promise;
            }
        }
    }

    angular.module("Waiteraid").factory("FullDayCache", FullDayCacheFactory);
})();
